export const SAVE_SMS = 'SAVE_SMS'

export const SMS_LIST = 'SMS_LIST'

export const DELETE_SMS = 'DELETE_SMS'